import React from 'react';
import {
  UserOutlined,
  DashboardOutlined,
  TeamOutlined,
  SettingOutlined,
  LogoutOutlined,
  MenuOutlined,
  UserSwitchOutlined,
  SafetyCertificateOutlined,
  DownOutlined,
  QuestionCircleOutlined,
  FileTextOutlined,
  BellOutlined,
} from '@ant-design/icons';
import { Image } from 'antd';
import AntdIcon from '@ant-design/icons';

interface IconProps {
  name: string;
  className?: string;
  style?: React.CSSProperties;
  width?: string | number;
}

const customIcons: { [key: string]: string } = {
  bell: '/bell_icon.svg',
  moon: '/moon_icon_outlined.svg',
  user: '/user_icon.svg',
  logout: '/logout_icon.svg',
};

const antdIcons: { [key: string]: React.ComponentType<any> } = {
  userOutlined: UserOutlined,
  dashboard: DashboardOutlined,
  team: TeamOutlined,
  setting: SettingOutlined,
  logoutOutlined: LogoutOutlined,
  menu: MenuOutlined,
  userSwitch: UserSwitchOutlined,
  safety: SafetyCertificateOutlined,
  down: DownOutlined,
  help: QuestionCircleOutlined,
  fileText: FileTextOutlined,
  bellOutlined: BellOutlined,
};

const Icon: React.FC<IconProps> = ({ name, className, style, width = '16px' }) => {
  if (customIcons[name]) {
    return (
        <AntdIcon 
            component={() => <img src={customIcons[name]} alt={name} width={width} />} 
            className={className}
            style={style}
        />
    );
  }

  const AntdIconComponent = antdIcons[name];
  if (AntdIconComponent) {
    return <AntdIconComponent className={className} style={style} />;
  }

  return null; // Or a default icon
};

export default Icon; 